import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WORKFLOW_IMG = '/assets/workflow.webp';

const milestones = [
  '01 Receive & Analyse Brief', '02 TAL Analysis & Dedup', '03 Unique Data Universe',
  '04 Suppression + CPC Filters', '05 Campaign Sign-Off', '06 Strategy & Channels',
  '07 Campaign Launch', '08 Parallel Execution', '09 Channel Implementation', '10 QA & Delivery',
];

export default function Workflow() {
  return (
    <section id="workflow" className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Operating Model</span>
            </div>
            <h2 className="text-4xl lg:text-6xl xl:text-7xl tracking-tight leading-[1.02] font-medium">
              Campaign Management Workflow — <span className="font-serif italic font-normal text-[#4ECDC4]">End-to-End Pipeline.</span>
            </h2>
            <p className="mt-4 text-white/70 text-[15px] max-w-2xl">
              Ten stages. Three QA gates. One accountable delivery pipeline — from brief to leads.
            </p>
          </div>
          <div className="lg:col-span-4 grid grid-cols-2 gap-4">
            <div className="bg-[#12234C] border border-white/10 rounded-lg p-4">
              <div className="text-4xl font-serif italic tabular text-[#4ECDC4]">10</div>
              <div className="text-xs text-white/60 mt-1">Stages end-to-end</div>
            </div>
            <div className="bg-[#4ECDC4] text-[#0F1C40] rounded-lg p-4">
              <div className="text-4xl font-serif italic tabular">03</div>
              <div className="text-xs mt-1">QA checkpoints</div>
            </div>
          </div>
        </div>

        {/* Workflow diagram image */}
        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-9 relative rounded-2xl overflow-hidden border border-white/10 bg-[#0A1530]">
            <img
              src={WORKFLOW_IMG}
              alt="Campaign management workflow diagram"
              className="w-full h-auto"
            />
          </div>
          <div className="lg:col-span-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-4">Key milestones</div>
            <ul className="space-y-2">
              {milestones.map((m, i) => {
                const isQA = ['04', '05', '10'].some((n) => m.startsWith(n));
                return (
                  <li key={m} className="flex items-start gap-2 text-[12px] leading-snug">
                    <span className={`w-2 h-2 rounded-full mt-1.5 shrink-0 ${isQA ? 'bg-[#4ECDC4]' : 'bg-white/30'}`} />
                    <span className={isQA ? 'text-[#4ECDC4] font-semibold' : 'text-white/80'}>{m}</span>
                    {isQA && <span className="text-[9px] font-mono uppercase text-[#4ECDC4]/80 ml-auto">QA</span>}
                  </li>
                );
              })}
            </ul>
            <div className="mt-6 pt-4 border-t border-white/10 flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-white/50">
              <CheckCircle2 className="w-3.5 h-3.5 text-[#4ECDC4]" />
              <span>Verified end-to-end</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
